<template>
    <div class="error-page">
        <!-- <div style="margin: aotu">
            <div class="testBox">
                <el-image class="PortraitImg" :src="testImg" fit="fill"></el-image>
                <div class="userName">
                    <div class="a">曹月月</div>
                    <div class="b">销售总监</div>
                </div>
            </div>
        </div> -->
        <div class="error-code">4<span>0</span>3</div>
        <div class="error-desc">啊哦~ 你没有权限访问该页面哦</div>
        <div class="error-handle">
            <router-link to="/">
                <el-button type="primary" size="large">返回首页</el-button>
            </router-link>
            <el-button class="error-btn" type="primary" size="large" @click="goBack()">返回上一页</el-button>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            testImg: require(`@/assets/img/sjylogo.png`)
        };
    },
    methods: {
        goBack() {
            this.$router.go(-1);
        }
    }
};
</script>

<style scoped lang="less">
/* .testBox {
    width: 300px;
    height: 300px;
    background: linear-gradient(-132deg, transparent 66px, #fff 0) right;
     background-size: 100% 100%; 
    background-repeat: no-repeat;
     border: 1px solid red;
}  */
.testBox {
    display: flex;
    height: 242px;
    width: 676px;
    border-radius: 15px;
    border: 1px solid #fff;
    align-items: center;
    justify-content: space-between;
    box-shadow: 0 2px 6px 0 rgba(0, 21, 41, 0.12);

    .PortraitImg {
    }
    .userName {
        color: #333;
        flex: 1;
        font-size: 50px;
        text-align: center;
        font-weight: bold;
        padding: 40px;
        .a {
            padding-bottom: 20px;
            border-bottom: 2px solid #333;
        }
        .b {
        }
    }
}
.error-code {
    color: #f02d2d;
}
</style>
